module.exports = __webpack_public_path__ + "img/cotizacion_agente.86a0d88b.svg";